import * as React from 'react';
import { translate } from 'react-i18next';
import { IPortalPageSection, IPortalSectionProps } from 'models/portal/page/portalpagesection';
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { PortalPageSectionItemRenderer } from 'components/PortalPage/SectionItems/SectionItemRenderer';
import * as c from 'models/constants';
import { SectionTitle } from 'components';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { IStore } from 'redux/IStore';
import { getFollowingOrFollowersButtonsData, followUser, unfollowItem } from 'redux/modules/user/usercard';
import { IFollowCardItem } from 'models/verticalwidgetcards/followcard';
import { IFollowerDto } from 'models/common';
import { followShop, unfollowShop } from 'redux/modules/shop/shopcard';
const { connect } = require('react-redux');
require('./style.css');

interface IOwnProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
	linkToMagazine?: string;
}

interface IProps extends IOwnProps {
	followingItems?: IFollowerDto[];
	getFollowingOrFollowersButtonsData?: () => void;
	followUser?: (id: string) => void;
	followShop?: (id: string) => void;
	unfollowUser?: (id: string) => void;
	unfollowShop?: (id: string) => void;
}

interface IState {
	isDragging: boolean;
	currentSlideIndex: number;
}

function followItemsFromSection(section: IPortalPageSection): IFollowCardItem[] {
	if (!section || !section.items || !section.items.length) {
		return [];
	}
	const elements: Array<string | undefined> = section.items.map((item) => {
		let type;
		let elementIndex;
		if (!item) {
			return undefined;
		}
		if (item.type === c.PORTAL_PAGE_SECTION_ITEM_PROFILE) {
			type = 'User';
			elementIndex = 4; // code is in index 4 if user card
		}
		if (item.type === c.PORTAL_PAGE_SECTION_ITEM_SHOP) {
			type = 'Shop';
			elementIndex = 7; // id is in index 7 if shop card
		}
		if (!type || !item.elements) {
			return undefined;
		}
		const code = item.elements[elementIndex] && (item.elements[elementIndex] as ISectionTextElement).text;
		if (!code) {
			return undefined;
		}
		return `{"id":"${code}","type":"${type}"}`;
		// return `{"type":"${type}","id":"${code}"}`;
	});
	const entityIds: string[] = elements.filter((s, i) => s && elements.indexOf(s) === i);
	return entityIds.map((entityId) => ({ entityId }));
}

@connect(
	(state: IStore) => ({
		followingItems: state.usercard.followingItems || [],
		// followingUserIds: getFollowingUserIds(state.usercard.followingItems),
	}),
	(dispatch, ownProps: IOwnProps) => {
		const gfofbd = () =>
			dispatch(getFollowingOrFollowersButtonsData(followItemsFromSection(ownProps.section), true, false));
		return {
			getFollowingOrFollowersButtonsData: gfofbd,
			followUser: (id: string) => dispatch(followUser(id, false, gfofbd)),
			followShop: (id: string) => dispatch(followShop(id, gfofbd)),
			unfollowUser: (id: string) => dispatch(unfollowItem(id, c.NODE_TYPE_USER, false, false, gfofbd)),
			unfollowShop: (id: string) => dispatch(unfollowShop(id, gfofbd)),
		};
	},
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType4 extends React.Component<IProps, IState> {
	private ref: React.RefObject<HTMLDivElement>;
	private mainRef: React.RefObject<HTMLDivElement>;
	private holderRef: React.RefObject<HTMLDivElement>;
	private titleRef: React.RefObject<HTMLDivElement>;

	constructor(props) {
		super(props);

		this.ref = React.createRef<HTMLDivElement>();
		this.mainRef = React.createRef<HTMLDivElement>();
		this.holderRef = React.createRef<HTMLDivElement>();
		this.titleRef = React.createRef<HTMLDivElement>();

		this.state = {
			isDragging: false,
			currentSlideIndex: 0,
		};

		this.setIsDragging = this.setIsDragging.bind(this);
		this.setCurrentSlideIndex = this.setCurrentSlideIndex.bind(this);

		this.followItem = this.followItem.bind(this);
		this.unfollowItem = this.unfollowItem.bind(this);

		this.onScroll = this.onScroll.bind(this);
		this.onResize = this.onResize.bind(this);
		this.handleMouseOut = this.handleMouseOut.bind(this);
		this.handleMouseMove = this.handleMouseMove.bind(this);
		this.stopMouseMove = this.stopMouseMove.bind(this);
		this.handleMouseDown = this.handleMouseDown.bind(this);
	}

	public componentDidMount() {
		this.props.getFollowingOrFollowersButtonsData();
		document.addEventListener('scroll', this.onScroll);
		document.addEventListener('mouseout', this.handleMouseOut);
		window.addEventListener('resize', this.onResize);
		this.onResize();
	}
	public componentWillUnmount() {
		document.removeEventListener('scroll', this.onScroll);
		document.removeEventListener('mouseout', this.handleMouseOut);
		window.removeEventListener('resize', this.onResize);
		this.stopAll();
		this.enableClick();
	}

	private resetScrollStyles() {
		if (this.mainRef.current) {
			this.mainRef.current.style.removeProperty('right');
		}
		if (this.holderRef.current) {
			this.holderRef.current.style.removeProperty('position');
			this.holderRef.current.style.removeProperty('bottom');
		}
		if (this.titleRef.current) {
			this.holderRef.current.style.removeProperty('position');
			this.holderRef.current.style.removeProperty('top');
		}
		this.stopAll();
	}

	private onResize() {
		if (!this.ref.current || !this.mainRef.current || this.props.isAdmin) {
			return this.resetScrollStyles();
		}
		this.onScroll();
	}

	private prevMousePosition: number | undefined;
	private innerRightPosition = 0;
	private get rightPosition() {
		return this.innerRightPosition;
	}
	private set rightPosition(val: number) {
		if (isNaN(val)) {
			console.error('Right position is NaN!');
			return;
		}
		val = Math.max(Math.min(val, this.maxRight), 0);
		this.innerRightPosition = val;
		if (this.mainRef.current) {
			this.mainRef.current.style.right = (String(Math.round(val)) || '0') + 'px';
		}
	}
	private get maxRight(): number | undefined {
		if (!this.mainRef.current || !this.holderRef.current) {
			return undefined;
		}
		return Math.max(0, this.mainRef.current.scrollWidth - this.holderRef.current.clientWidth);
	}

	private handleMouseDown(e: React.MouseEvent) {
		this.prevMousePosition = e.clientX;
		this.stopMarquee();
		document.addEventListener('mousemove', this.handleMouseMove);
		document.addEventListener('mouseup', this.stopMouseMove);
		e.preventDefault();
	}

	private handleMouseMove(e: MouseEvent) {
		this.disableClick();
		if (this.prevMousePosition === undefined) {
			this.prevMousePosition = e.clientX;
			return;
		}
		this.stopMarquee();
		const change = this.prevMousePosition - e.clientX;
		if (change !== 0) {
			this.rightPosition += change;
		}
		this.prevMousePosition = e.clientX;
	}

	private clickDisablingTimeout: ReturnType<typeof setTimeout>;
	private disableClick() {
		if (this.clickDisablingTimeout !== undefined) {
			return;
		}
		this.clickDisablingTimeout = setTimeout(() => {
			if (!this.state.isDragging) {
				this.setState({
					isDragging: true,
				});
			}
		}, 100);
	}
	private enableClick() {
		clearTimeout(this.clickDisablingTimeout);
		this.clickDisablingTimeout = undefined;
		requestAnimationFrame(() => {
			if (this.state.isDragging) {
				this.setState({
					isDragging: false,
				});
			}
		});
	}

	private stopMouseMove() {
		this.enableClick();
		document.removeEventListener('mousemove', this.handleMouseMove);
	}

	private handleMouseOut(evt: MouseEvent) {
		// mouse left window
		if (!(evt as any).toElement && !evt.relatedTarget) {
			this.stopMouseMove();
		}
	}

	private stopAll() {
		this.enableClick();
		this.prevMousePosition = undefined;
		document.removeEventListener('mousemove', this.handleMouseMove);
		document.removeEventListener('mouseup', this.stopMouseMove);
		this.stopMarquee();
	}

	private animationFrameWait: ReturnType<typeof requestAnimationFrame>;
	private timeout: ReturnType<typeof setTimeout>;

	private stopMarquee() {
		if (this.animationFrameWait !== undefined) {
			cancelAnimationFrame(this.animationFrameWait);
			this.animationFrameWait = undefined;
		}
		if (this.timeout !== undefined) {
			clearTimeout(this.timeout);
			this.timeout = undefined;
		}
	}
	private marqueeTime = undefined;
	private marqueeDirection: 'left' | 'right' = 'left';
	private marqueeStep() {
		const maxRight = this.maxRight;
		if (!maxRight) {
			return this.stopMarquee();
		}
		if (this.marqueeTime !== undefined) {
			const milliDiff = Date.now() - this.marqueeTime;
			if (milliDiff > 0) {
				const move = milliDiff * 0.1;
				let right = this.rightPosition;
				if (this.marqueeDirection === 'left') {
					right += move;
					if (right >= maxRight) {
						this.marqueeDirection = 'right';
					}
				} else {
					right -= move;
					if (right <= 0) {
						this.marqueeDirection = 'left';
					}
				}
				this.rightPosition = right;
			}
		}
		this.timeout = setTimeout(() => {
			this.animationFrameWait = requestAnimationFrame(() => {
				this.marqueeStep();
			});
		}, 10);
		this.marqueeTime = Date.now();
	}

	private isInView = false;
	private onScroll() {
		if (!this.ref.current || !this.mainRef.current || !this.holderRef.current || this.props.isAdmin) {
			return this.resetScrollStyles();
		}
		const rect = this.ref.current.getBoundingClientRect();
		if (rect.bottom < 0 || rect.top > window.innerHeight) {
			this.isInView = false;
			return this.stopAll();
		} else {
			if (!this.isInView) {
				this.marqueeStep();
			}
			this.isInView = true;
		}
	}

	private followItem(type: string, id: string) {
		if (type.toLowerCase() === 'user') {
			return this.props.followUser(id);
		}
		if (type.toLowerCase() === 'shop') {
			return this.props.followShop(id);
		}
	}
	private unfollowItem(type: string, id: string) {
		if (type.toLowerCase() === 'user') {
			return this.props.unfollowUser(id);
		}
		if (type.toLowerCase() === 'shop') {
			return this.props.unfollowShop(id);
		}
	}

	private setIsDragging(isDragging: boolean) {
		this.setState({ isDragging });
		this.forceUpdate();
	}

	private setCurrentSlideIndex(currentSlideIndex: number) {
		this.setState({ currentSlideIndex });
		this.forceUpdate();
	}

	private get slides() {
		// only with title
		return this.props.section.items
			.slice(1)
			.filter(
				(item) =>
					item.type &&
					item.elements &&
					item.elements.length &&
					item.elements[2] &&
					(item.elements[2] as ISectionTextElement).text,
			);
	}

	public render() {
		const { items, type } = this.props.section;
		const { isDragging } = this.state;

		const slides = this.slides;

		const renderedItems = slides.map((item: IPortalPageSectionItem, index: number) => {
			const isFirstItemInRow: boolean = index === 0;
			const isLastItemInRow: boolean = index === slides.length - 1 || (index + 1) % 4 === 0;
			return (
				<div key={'portalpagesectionrenderer_' + (item ? item.type : 'empty') + '_' + index}>
					<PortalPageSectionItemRenderer
						portalPageSectionItem={item}
						isLastItemInRow={isLastItemInRow}
						isFirstItemInRow={isFirstItemInRow}
						sectionType={type}
						isDragging={isDragging}
						followingItems={this.props.followingItems}
						followItem={this.followItem}
						unfollowItem={this.unfollowItem}
					/>
				</div>
			);
		});

		let title = '';
		if (items.length && items[0] && items[0].elements && items[0].elements.length) {
			title = (items[0].elements[0] as ISectionTextElement).text;
		}

		return (
			<div className="portalPageSectionType4" ref={this.ref} onMouseDown={this.handleMouseDown}>
				<div className="holder">
					<SectionTitle holderRef={this.titleRef} variant="white">
						{title}
					</SectionTitle>
					<div className="itemsHolder" ref={this.holderRef}>
						<div className="items" ref={this.mainRef}>
							{renderedItems}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType4 };
